<nav class="horizontal-menu">
	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.stockManager()">
		<mat-icon>bar_chart</mat-icon>
		{{ 'admin_console.stock_management' | translate }}
	</a>
	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.tradeGroups()">
		<div class="wrapper-ingrediants">
			<img src="../../../assets/ingredient.png" />

			<p>Trade Groups</p>
		</div>
	</a>
	<!-- <a mat-raised-button>
    <mat-icon>settings</mat-icon>
    {{ 'admin_console.machine' | translate }}
  </a>
  <a mat-raised-button>
    <mat-icon>print</mat-icon>
    {{ 'admin_console.printer_settings' | translate }}
  </a> -->

	@if (venueValue$ | async; as venue) {
		<a
			mat-raised-button
			class="button-delivery"
			(click)="updateUber()"
			*ngIf="checkIfSetupOrderProviders(venue, 'uber_eat')"
		>
			<div>
				<img
					src="/assets/uber_eats.png"
					class="logo"
					height="15"
					alt="uber_logo"
				/>
				@if (isVenueOpen$ | async) {
					@if (isUberEatsActiveInVenue$ | async) {
						<h3 class="green">{{ 'common.online' | translate }}</h3>
					} @else {
						<h3 class="red">
							{{ 'common.offline' | translate }}
							<p *ngIf="venue.externalOrderProviders?.uberEats?.snoozed">
								bis:
								{{
									venue.externalOrderProviders.uberEats.snoozed
										| date: 'HH:mm dd.MM'
								}}
							</p>
						</h3>
					}
					<h5
						(click)="updateUberBusyMode($event)"
						*ngIf="isUberEatsActiveInVenue$ | async"
						style="
							margin-top: 10px;
							border: 2px solid var(--mdc-protected-button-label-text-color);
							border-radius: 4px;
							padding: 0 6px;
						"
					>
						Busy mode: {{ uberBusyMode?.active ? 'on' : 'off' }}
					</h5>
				} @else {
					<h3 class="red">{{ 'common.closed' | translate }}</h3>
				}
			</div>
		</a>
	}

	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.openingHours()">
		<mat-icon>access_time</mat-icon>
		{{ 'admin_console.opening_hours' | translate }}
	</a>
	<a mat-raised-button (click)="openDialog()">
		<mat-icon>settings</mat-icon>
		Printer Settings
	</a>

	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.timeSettings()">
		<mat-icon>settings</mat-icon>
		{{ 'admin_console.time_settings' | translate }}
	</a>
	<a mat-raised-button class="button-delivery last-btn" (click)="turnOnMusic()">
		<div>
			<h3 class="title-text">Sound</h3>
			@if (AppComponent.musicOn) {
				<h3 class="green">on</h3>
			} @else {
				<h3 class="red">off</h3>
			}
		</div>
	</a>
	<a mat-raised-button (click)="logout()" class="out-color">
		<mat-icon>logout</mat-icon>
		{{ 'common.logout' | translate }}
	</a>
</nav>
